import React from 'react';

const DetailComponent = ({detailData}) => {  
    return (
        <div className="details-row"> 
                       <table>
                          <thead>
                            <tr> 
                              <th>PickupDate</th>
                              <th>PickupTime</th>
                              <th>Pickup Point</th> 
                              <th>Hotel</th>
                              <th>PAX</th> 
                              <th>participants</th> 
                              <th>RefNumber</th> 
                              <th>Flight</th> 
                              <th>Client</th>
                            </tr>
                          </thead>
                          <tbody> 
                            {detailData.map(iteminner => (
                                <React.Fragment key={iteminner.i}> 
                                  <tr>
                                    <td>{iteminner.PickupDate}</td>
                                    <td>{iteminner.PickupTime}</td>
                                    <td>{iteminner.PickupPoint}</td> 
                                    <td>{iteminner.Hotel}</td>
                                    <td>{iteminner.PAX}</td>
                                    <td>{iteminner.participants}</td>
                                    <td>{iteminner.RefNumber}</td> 
                                    <td>{iteminner.Flight}</td> 
                                    <td>{iteminner.Client}</td>
                                  </tr>
                                </React.Fragment>
                             ))}

                          </tbody>
                    </table>
                </div>
    );
};
export default DetailComponent;